import { NavLink } from "react-router-dom";
import Faq from "./faq";
import { useEffect } from "react";
import { CONTACT_CONFIG } from '../config/contact';

export default function Privacy() {
  // Utilisation des variables de configuration centralisées
  const contactInfo = CONTACT_CONFIG;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {/* Header Section */}
      <section className="bg-gradient-to-r from-[#00d4ff] to-[#090979] text-white py-8">
        <div className="h-[25vh]"></div>
        <div className="main-content">
          {/* Main Title */}
          <div className="text-center">
            <h1 className="text-4xl font-bold">Política de Privacidad</h1>
          </div>
          {/* Navigation Breadcrumbs */}
          <div className="text-center mb-4">
            <span className="text-sm">
              <NavLink
                to="/"
                className="transition-all duration-500 hover:text-[#090979]"
                onClick={scrollToTop}
              >
                Inicio
              </NavLink>{" "}
              /{" "}
              <span className="text-gray-300">
                Política de Privacidad
              </span>
            </span>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="bg-slate-50 text-[#1B1B1B] py-12 min-h-[80vh]">
        <div className="main-content w-[85%] m-auto">
          <div className="space-y-8">
            {/* Section 1 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                1. Información que recopilamos
              </h2>
              <p className="text-base leading-relaxed">
                Recopilamos la información que usted nos proporciona
                directamente, como su nombre, dirección de correo electrónico e información de
                pago cuando se suscribe a nuestros servicios IPTV. Esta
                información es necesaria para proporcionar nuestros servicios y
                procesar sus pagos.
              </p>
            </div>

            {/* Section 2 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                2. Cómo utilizamos su información
              </h2>
              <p className="text-base leading-relaxed">
                Utilizamos su información para proporcionar, mantener y
                mejorar nuestros servicios IPTV, procesar sus pagos, comunicarnos
                con usted sobre su cuenta y enviarle actualizaciones
                importantes sobre nuestros servicios.
              </p>
            </div>

            {/* Section 3 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                3. Compartir su información
              </h2>
              <p className="text-base leading-relaxed">
                No vendemos, intercambiamos ni alquilamos su información
                personal a terceros. Podemos compartir su información
                únicamente con nuestros proveedores de servicios de pago para
                procesar sus transacciones, y solo en la medida
                necesaria.
              </p>
            </div>

            {/* Section 4 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">
                4. Seguridad de sus datos
              </h2>
              <p className="text-base leading-relaxed">
                Implementamos medidas de seguridad apropiadas para
                proteger su información personal contra el acceso no
                autorizado, la modificación, la divulgación o la destrucción. Sus
                datos están cifrados y almacenados de forma segura.
              </p>
            </div>

            {/* Section 5 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">5. Sus derechos</h2>
              <p className="text-base leading-relaxed">
                Tiene derecho a acceder, corregir o eliminar su
                información personal en cualquier momento. También puede
                oponerse al procesamiento de sus datos o solicitar la
                portabilidad de su información.
              </p>
            </div>

            {/* Section 6 */}
            <div>
              <h2 className="text-2xl font-bold mb-4">6. Contáctenos</h2>
              <p className="text-base leading-relaxed mb-4">
                Para cualquier pregunta sobre esta política de privacidad o
                para ejercer sus derechos, puede contactarnos a través de:
              </p>
              <ul className="list-disc list-inside space-y-2 text-base">
                <li>Email : {contactInfo.email}</li>
                <li>
                  WhatsApp :{" "}
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline hover:text-blue-800"
                  >
                    Haga clic aquí para contactarnos
                  </a>
                </li>
              </ul>
            </div>

            {/* Conclusion */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-base leading-relaxed">
                Gracias por elegir {contactInfo.companyName}. Estamos orgullosos de garantizar
                su privacidad y ofrecerle un servicio de alta
                calidad sin comprometer su seguridad o su anonimato.
              </p>
            </div>
          </div>
        </div>
        <Faq />
      </section>
    </>
  );
}
